// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"379":"c2779947","498":"566c02be","703":"eb95796f"}[chunkId] + ".chunk.js";
};